/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {getListGuestsExcelService, paginationGuestsService} from '../../services/getBeds.service'
// import { BedModel } from '../../model/bed.model'
import moment from 'moment'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useGuests} from '../../../../hooks/useGuests'
import {GuestModel} from '../../model'
import {useRooms} from '../../../../hooks/useRooms'
import {useModules} from '../../../../hooks/useModules'
import {useBed} from '../../../../hooks/useBed'
import { getSnackBarToast } from '../../../../../../util/snackBar'

const TableGuests: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, getClients, getSites, getCamps, getDocumentTypes} = useCentralServices()
  const {getTypeStayGuest, getTypeGuest} = useGuests()

  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])
  const [camp, setCamps] = useState<SelectOption[]>([])
  const [cargos, setCargos] = useState<SelectOption[]>([])
  const [guestStatus, setGuestStatus] = useState<SelectOption[]>([])
  const [documentTypes, setDocumentTypes] = useState<SelectOption[]>([])
  const [typeStayGuest, setTypeStayGuest] = useState<SelectOption[]>([])
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const {getMasterTable} = useCentralServices()

  useEffect(() => {
    getCompaniesFn()
    getDocumentTypesFn()
    getTypeStayGuestFn()
    gestGuestStatusFn()
    getClientsFn()
    getSitesFn()
    getCampsFn()
    getCargosFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    setClient(data)
  }

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSites(data)
  }

  const getCampsFn = async () => {
    const data = await getCamps({isCombo: true}, 1)
    setCamps(data)
  }

  const getCargosFn = async () => {
    const data = await getMasterTable('Cargo', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setCargos(allData)
  }

  const getDocumentTypesFn = async () => {
    const data = await getDocumentTypes()
    setDocumentTypes(data)
  }

  const gestGuestStatusFn = async () => {
    const data = await getTypeGuest()
    setGuestStatus(data)
  }

  const getTypeStayGuestFn = async () => {
    const data = await getTypeStayGuest()
    setTypeStayGuest(data)
  }

  const handlePaginationGuests = async () => {
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await paginationGuestsService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEditItem = (item: GuestModel) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'guest-detail',
      },
      idToDelete: '',
      idToEdit: item.Id,
      objectInfo: item,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetById = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<GuestModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetById}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name={'CampamentoId'}
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='ModuloCodigo'
            searcheable
          />
        ),
        accessor: 'Modulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='HabitacionCodigo'
            searcheable
          />
        ),
        accessor: 'Habitacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CamaCodigo'
            searcheable
          />
        ),
        accessor: 'Cama_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estatus de Huésped'
            name='TipoHuespedId'
            selecteable
            data={guestStatus}
          />
        ),
        accessor: 'TipoHuesped_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Ap. Paterno' name='ApellidoPaterno' searcheable />
        ),
        accessor: 'ApellidoPaterno',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Ap. Materno' name='ApellidoMaterno' searcheable />
        ),
        accessor: 'ApellidoMaterno',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name='Nombres' searcheable />
        ),
        accessor: 'Nombres',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo Doc.'
            name='TipoDocumentoId'
            selecteable
            data={documentTypes}
          />
        ),
        accessor: 'TipoDocumento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Documento' name='NumeroDocumento' searcheable />
        ),
        accessor: 'NumeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Email' name='Email' searcheable />
        ),
        accessor: 'Email',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono' name='Telefono' searcheable />
        ),
        accessor: 'Telefono',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            name={'CargoId'}
            title='Cargo'
            selecteable
            data={cargos}
          />
        ),
        accessor: 'Cargo_descripcion',
        Cell: ({...props}) => (
          <div>
            {!props.row.original.Cargo_descripcion
              ? 'CUALQUIERA'
              : props.row.original.Cargo_descripcion}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Huésped'
            name='EmpresaSubContratistaUsuario'
            searcheable
          />
        ),
        accessor: 'Empresa_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Estadía'
            name='TipoEstadiaId'
            selecteable
            data={typeStayGuest}
          />
        ),
        accessor: 'TipoEstadia_descripcion',
      },

      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEditItem(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [compani, client, site, camp, documentTypes, guestStatus, cargos, typeStayGuest, selectedOn],
  )

  useEffect(() => {
    handlePaginationGuests()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      handlePaginationGuests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      handlePaginationGuests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.updated) {
      clearSelected()
      handlePaginationGuests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.updated])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        handlePaginationGuests()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        handlePaginationGuests()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleExport = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getListGuestsExcelService({
        pageNumber: pagination.currentPage,
        size: 0,
        ...searchValues,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Huespedes-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='m-5'>
          {isAllowed('EXPORTAR') && (
            <ButtonWrapper className={'sdx-white-bg'}>
              <button
                type='button'
                className='sdx_btn'
                disabled={data.length < 1 || isDownloadXLS}
                onClick={handleExport}
              >
                {isDownloadXLS && (
                  <div className='icon-container' style={{margin: '0px 15px 0px 0px'}}>
                    <i className='loader'></i>
                  </div>
                )}
                Exportar
              </button>
            </ButtonWrapper>
          )}
          <KTable data={data} columns={columns as any} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableGuestsWrapper = () => {
  return (
    <KTableProvider>
      <TableGuests />
    </KTableProvider>
  )
}

export {TableGuestsWrapper}
